// zustand docs -> https://github.com/pmndrs/zustand
import create from 'zustand';
import { persist } from 'zustand/middleware';

import { THEME_TYPES } from '../constants';

const { THEME_LIGHT, THEME_DARK } = THEME_TYPES;

const store = (set) => ({
    theme: THEME_LIGHT,
    toggleTheme: () =>
        set((state) => ({
            theme: state.theme === THEME_LIGHT
                ? THEME_DARK
                : THEME_LIGHT,
        })),
});

const useThemeStore = create((persist(store, {
    name: 'theme'
})));

export default useThemeStore;